import axios, { AxiosRequestConfig } from 'axios';
import { Booking, DataResponse, PagedResponse } from '../types';

const URL = '/v2/bookings';

class BookingService {
  static get(
    id: number,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Booking>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getByFilter(
    config?: AxiosRequestConfig
  ): Promise<PagedResponse<Booking>> {
    return axios.get(URL, config);
  }

  static create(
    data: Booking,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Booking>> {
    return axios.post(URL, data, config);
  }

  static patch(
    id: number,
    data: Booking,
    config?: AxiosRequestConfig
  ): Promise<DataResponse<Booking>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}

export { BookingService };
